export const mockAdminRegisterFields = [
  {
    name: "firstName",
    type: "text",
    label: "First Name",
    gridColumn: "span 2",
  },
  { name: "lastName", type: "text", label: "Last Name", gridColumn: "span 2" },
  { name: "email", type: "email", label: "Email", gridColumn: "span 4" },
  { name: "password", type: "password", label: "Password", gridColumn: "span 4" },
  {
    name: "phoneNumber",
    type: "text",
    label: "Phone Number",
    gridColumn: "span 2",
  },
  { name: "age", type: "number", label: "Age", gridColumn: "span 2" },
  {
    name: "profilePicture",
    type: "file",
    label: "Profile Picture",
    gridColumn: "span 4",
  },
];

export const mockAdminLoginFields = [
  { name: "email", type: "email", label: "Email", gridColumn: "span 4" },
  { name: "password", type: "password", label: "Password", gridColumn: "span 4" },
];
